import React, { useEffect, useRef, useState } from "react";
import FogHeroVideo from "../../videos/FOG/FOG_Hero.mp4";
import FogMarshalsVideo from "../../videos/FOG/FOG_Grand_Marshals.mp4";
/* ---------- Hook: detect when section/division is active ---------- */
function useInView({ threshold = 0.25, rootMargin = "0px 0px -10% 0px" } = {}) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(([entry]) => setActive(entry.isIntersecting), {
      threshold,
      rootMargin,
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, rootMargin]);

  return { ref, active };
}

/* ---------- Text-only division (NO IMAGES) ---------- */
function TextDivision({ title, reverse = false, children }) {
  const { ref, active } = useInView({ threshold: 0.25 });

  return (
    <div ref={ref} className={`fog-division mt-5 ${active ? "is-active" : ""}`}>
      <div className={`row align-items-center g-4 ${reverse ? "flex-md-row-reverse" : ""}`}>
        <div className="col-12">
          <h3 className="white">{title}</h3>
          {children}
        </div>
      </div>
    </div>
  );
}

function FogServicePrograms() {
  // ✅ Replace with your actual video (local import or URL)
  const HERO_VIDEO_SRC = FogHeroVideo;
  const MARSHALS_VIDEO_SRC = FogMarshalsVideo;

  const [isMuted, setIsMuted] = useState(true);
const [isPlaying, setIsPlaying] = useState(true);
const videoRef = useRef(null);

useEffect(() => {
  const v = videoRef.current;
  if (!v) return;

  // help autoplay
  v.muted = true;

  const p = v.play();
  if (p && typeof p.then === "function") {
    p.then(() => setIsPlaying(true)).catch(() => setIsPlaying(false));
  } else {
    setIsPlaying(!v.paused);
  }
}, []);

const togglePlayPause = async () => {
  const v = videoRef.current;
  if (!v) return;

  if (v.paused) {
    try {
      await v.play();
      setIsPlaying(true);
    } catch {
      setIsPlaying(false);
    }
  } else {
    v.pause();
    setIsPlaying(false);
  }
};

const toggleMute = () => setIsMuted((m) => !m);

  return (
    <>
      <style>{`
        html, body { overflow-x: hidden; }

        /* ✅ Text reveal (optional; safe even if your theme overrides) */
        .fog-division{
          opacity: 0;
          transform: translateY(18px);
          filter: blur(6px);
          transition: opacity 650ms ease, transform 650ms ease, filter 650ms ease;
          will-change: opacity, transform, filter;
        }
        .fog-division.is-active{
          opacity: 1;
          transform: translateY(0);
          filter: blur(0);
        }

        /* ✅ FULL-WIDTH + FULL-HEIGHT VIDEO SECTION */
        .fog-fullVideo{
          width: 90%;
  max-width: 1600px;
  margin: 40px auto;
  height: auto;
  background: #000;
  position: relative;
  overflow: visible;
}
        .fog-fullVideo video{
          width: 100%;
  height: auto;
  object-fit: contain;
}

        

        .mt-4{
          margin-top: 1.5rem !important;
        }

        .fog-containerVideo{
          width: 100%;
          margin-top: 1.5rem;
          border-radius: 14px;
          overflow: hidden;
          background: #000;
        }

        .fog-containerVideo video{
          width: 100%;
          height: auto;
          display: block;
          background: #000;
        }

        .a4h-videoControls{
          position: absolute;
          top: auto;
          right: auto;
          bottom: 16px;
          left: 16px;
          display: flex;
          gap: 10px;
          z-index: 3;
        }

        .a4h-ctrlBtn{
          border: 1px solid rgba(255,255,255,.22);
          background: rgba(0,0,0,.45);
          color: #fff;
          border-radius: 999px;
          padding: 10px 14px;
          font-size: 13px;
          letter-spacing: .02em;
          backdrop-filter: blur(10px);
          cursor: pointer;
          white-space: nowrap;
        }
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
/* Remove line/divider under heading */
.hra-topTitle::before,
.hra-topTitle::after,
.head-title::before,
.head-title::after {
  display: none !important;
  content: none !important;
  border: none !important;
}
.hra-topTitle{
  margin-bottom: -32px !important;
}
        .a4h-ctrlBtn:hover{ background: rgba(0,0,0,.6); }
.a4h-btn-icon{
  display:none;
}

.a4h-btn-text{
  display:inline;
}
        /* =========================
   PERFECT MOBILE VERSION
   ========================= */
@media (max-width: 768px) {

  /* remove extra spacing */
  .block.color-scheme-4{
    padding-top: 0 !important;
  }

  .container{
    padding-left: 14px !important;
    padding-right: 14px !important;
  }

  /* heading */
  .hra-topTitle{
    margin-top: 20px !important;
    margin-bottom: -48px !important;
  }

  .hra-topTitle span{
    font-size: 1.1rem !important;
    line-height: 1.2 !important;
    display: block;
  }

  /* divider */
  .section-divider{
    margin: 14px auto 16px !important;
    gap: 10px !important;
  }

  .section-divider span{
    font-size: 16px !important;
  }

  .section-divider::before,
  .section-divider::after{
    height: 2px !important;
  }

  /* intro text */
  .hra-topIntro{
    font-size: 0.95rem !important;
    line-height: 1.6 !important;
    margin-top: 10px !important;
  }

  /* hero video */
  .fog-fullVideo{
    width: 100% !important;
    margin: 18px auto !important;
    height: auto !important;
    aspect-ratio: unset !important;
    border-radius: 10px;
  }

  .fog-fullVideo video{
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  /* control buttons */
  .a4h-videoControls{
    bottom: 6px !important;
    left: 6px !important;
    gap: 4px !important;
  }

  .a4h-btn-text{
  display:none;
}

.a4h-btn-icon{
  display:inline;
  font-size:20px;
  line-height:1;
}

.a4h-videoControls{
  bottom:6px !important;
  left:6px !important;
  gap:4px !important;
}

.a4h-ctrlBtn{
  background:transparent !important;
  border:none !important;
  box-shadow:none !important;
  backdrop-filter:none !important;
  padding:0 !important;
  width:auto !important;
  height:auto !important;
  min-width:auto !important;
  border-radius:0 !important;
  color:#fff;
  cursor:pointer;
}

.a4h-ctrlBtn:hover,
.a4h-ctrlBtn:focus,
.a4h-ctrlBtn:active{
  background:transparent !important;
  box-shadow:none !important;
}

  /* body paragraphs */
  .col-md-10.col-lg-9 p{
    font-size: 0.95rem !important;
    line-height: 1.7 !important;
    margin-bottom: 12px !important;
  }

  /* section titles */
  .fog-division h3{
    font-size: 0.9rem !important;
    line-height: 1.3 !important;
    margin-bottom: 10px !important;
  }

  /* lists */
  .arrow-list li{
    font-size: 0.95rem !important;
    line-height: 1.6 !important;
    margin-bottom: 8px !important;
  }

  /* reduce section gaps */
  .fog-division{
    margin-top: 20px !important;
  }

  .mt-4{
    margin-top: 0.75rem !important;
  }

  /* grand marshals video */
  .fog-containerVideo{
    margin-top: 12px !important;
    border-radius: 10px !important;
  }

  .fog-containerVideo video{
    width: 100%;
    height: auto;
  }

  /* remove extra breaks */
  br{
    display: none;
  }
}

      `}</style>

      <section>
        <div className="block color-scheme-4">
          {/* ✅ 1) FIRST: Heading + small intro content */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article className="section-title-body white">
                    <h1 className="head-title hra-topTitle">
                      <span>FOG Annual India Day Parade & Fair (Mela)</span>{" "}
                      <div className="section-divider">
  <span>✦ ✦ ✦</span>
</div> 
                      
                    </h1>

                    <p className="hra-topIntro">
                      Festival of Globe is one of the largest platforms celebrating
                      Indian and Hindu culture in the US. Its programs inspire
                      pride, cultural heritage, and intergenerational unity.
                    </p>
                  </article>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ 2) SECOND: Video FULL WIDTH + FULL HEIGHT */}
            <div className="fog-fullVideo">
            <video
              ref={videoRef}
              src={HERO_VIDEO_SRC}
              playsInline
              autoPlay
              loop
              muted={isMuted}
              preload="metadata"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />
            <div className="a4h-videoControls">
  <button
    type="button"
    className="a4h-ctrlBtn"
    onClick={togglePlayPause}
  >
    <span className="a4h-btn-text">
      {isPlaying ? "Pause ⏸️" : "Play ▶️"}
    </span>
    <span className="a4h-btn-icon">
      {isPlaying ? "⏸️" : "▶️"}
    </span>
  </button>

  <button
    type="button"
    className="a4h-ctrlBtn"
    onClick={toggleMute}
  >
    <span className="a4h-btn-text">
      {isMuted ? "Unmute 🔊" : "Mute 🔇"}
    </span>
    <span className="a4h-btn-icon">
      {isMuted ? "🔇" : "🔊"}
    </span>
  </button>
</div>
          </div>

          
          
          <br/>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <p><b>Festival of Globe</b> is a federally recognized <b>501(c)(3) nonprofit organization</b> dedicated to celebrating cultural diversity, democratic values, and global unity through large-scale public engagement. Widely known for organizing the <b>largest India Day Parade in the United States</b>, the organization provides a prominent platform for showcasing India’s independence, rich heritage, and pluralistic traditions while fostering cross-cultural understanding. Over the decades, Festival of Globe has earned widespread recognition and official proclamations from cities and counties across the Bay Area for its excellence in community service, cultural programming, and civic outreach, solidifying its reputation as a nationally respected institution with enduring impact.</p>
              </div>
            </div>
          </div>

          {/* ✅ 3) THIRD: Remaining content AFTER video (PRESERVED, NO IMAGES) */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article className="section-title-body white">
                    <TextDivision title="Cultural Preservation Programs">
                      <ul className="white mt-4 arrow-list">
                        <li>Classical &amp; Modern Dance Competitions</li>
                        <li>Kids Talent Shows</li>
                        <li>FOG Idol Singing Competitions</li>
                        <li>Bollywood &amp; Folk Dance Showcases</li>
                        <li>Regional State Performances</li>
                        <li>Film Awards &amp; FOG Film Festival</li>
                      </ul>
                    </TextDivision>

                    <TextDivision title="Community Wellness &amp; Service" reverse>
                      <ul className="white mt-4 arrow-list">
                        <li>Annual Health Fair</li>
                        <li>Medical screenings &amp; community well-being camps</li>
                        <li>Senior support programs</li>
                        <li>Interfaith service collaborations</li>
                      </ul>

                      {/* ✅ Container-width video at the bottom of this section */}
                      <TextDivision title="OUR GRAND MARSHALS" reverse>
                      <div className="fog-containerVideo">
                        <video
                          src={MARSHALS_VIDEO_SRC}
                          controls
                          muted
                          playsInline
                          preload="metadata"
                        />
                      </div>
                      </TextDivision>
                    </TextDivision>
                    <br/>
                    
                    <TextDivision title="Education &amp; Youth Programs">
                      <ul className="white mt-4 arrow-list">
                        <li>Youth Leadership Workshops</li>
                        <li>Language &amp; Cultural Education</li>
                        <li>College &amp; Career Readiness Sessions</li>
                      </ul>
                    </TextDivision>
                  </article>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default FogServicePrograms;
